export enum TipoConsultaBarcode {
    GERACAO_MANIFESTO_TRANSFERENCIA = 1,
    RECEPCAO_MANIFESTO_TRANSFERENCIA = 2,
    GAIOLA_PEDIDOS_VOLUMES = 3,
    GAIOLA_PEDIDOS_REMOVER_VOLUMES = 4,
    RECEPCAO_FISICA = 5,
    GAIOLA_CONSULTA_VOLUMES = 6,
    CONSULTA_FAE = 7,
    CONSULTA_FAE_RETORNO = 9,
    INVENTARIO = 50,
    MDT_GERAR = 20,
    MDT_ALTERAR = 21,
    RECEPCAO_MDT = 22,
    MDC_RECEPCAO_BARCODE = 23,
    MDC_GERACAO = 30,
    PEDIDOSPENDENTESBARCODE = 40,
    PEDIDOSPENDENTESROMANEIO = 41,
    NAO_VALIDA_DATA_EMISSAO = 46,
    GAIOLA_OPERACAO_VOLUME = 60
}
